// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"a245cc768ffed8421768","655":"04e8396e5629b7719480"}[chunkId] + ".js";
};